import { Component,
    Input,
    Output,
    OnChanges,
    EventEmitter,
    ChangeDetectionStrategy,
    ContentChild, TemplateRef
} from '@angular/core';
import { TreeNodeComponent } from './tree-node.component';
import { TreeService } from '../services/tree.service';
import { TreeOptions } from '../models/tree-options.model';
import { KEYS } from '../constants/keys';
const _ = require('lodash');

@Component({
    selector: 'Tree',
    host: {
        '(body: keydown)': 'onKeydown($event)',
        '(body: mousedown)': 'onMousedown($event)'
    },
    providers: [TreeService],
    styles: [require('./tree.scss')],
    template: `
    <div class="tree">
      <TreeNode
        (click)="treeService.setFocus(true)"
        *ngFor="let node of treeService.roots; let i = index"
        [node]="node" [index]="i" [iconTemplate]="iconTemplate">
      </TreeNode>
      <span *ngIf="!treeService.roots.length" class="spinner"></span>
    </div>
  `
})

export class TreeComponent implements OnChanges {

    @Output() onToggle;
    @Output() onActiveChanged;
    @Output() onRightClick;
    @Output() onActivate;
    @Output() onDeactivate;
    @Output() onFocus;
    @Output() onBlur;
    @Output() onInit;
    @Output() onSearchComplete;
    @Output() onUpdate;
    @Output() onLoadChildren;
    @Input() changeTrigger;

    @ContentChild('iconTemplate') iconTemplate: TemplateRef<any>;

    constructor(public treeService: TreeService) {
        treeService.eventNames.forEach((name) => this[name] = new EventEmitter());
    }

    @Input() set nodes(nodes: any[]) {};

    @Input() set options(options: TreeOptions) { };

    @Input() set focused(value: boolean) {
        this.treeService.setFocus(value);
    }
    onKeydown($event) {
        if (!this.treeService.isFocused) return;
        if (_.includes(['input', 'textarea'],
                document.activeElement.tagName.toLowerCase())) return;
        let focusedNode = this.treeService.getFocusedNode();
        if (_.includes([KEYS.DOWN, KEYS.UP, KEYS.LEFT,
                KEYS.RIGHT, KEYS.ENTER, KEYS.SPACE], $event.keyCode)) {
            $event.preventDefault();
        }

        switch ($event.keyCode) {
            case KEYS.DOWN:
                return this.treeService.focusNextNode();

            case KEYS.UP:
                return this.treeService.focusPreviousNode();

            case KEYS.LEFT:
                if (focusedNode.isExpanded) {
                    focusedNode.toggle();
                } else {
                    this.treeService.focusDrillUp();
                }
                return;

            case KEYS.RIGHT:
                if (focusedNode.isCollapsed) {
                    focusedNode.toggle();
                } else {
                    this.treeService.focusDrillDown();
                }
                return;

            case KEYS.ENTER:
            case KEYS.SPACE:
                return focusedNode && focusedNode.toggleActivated();
            default:
        }
    }

    onMousedown($event) {
        let insideClick = $event.target.closest('Tree');
        if (!insideClick) {
            this.treeService.setFocus(false);
        }
    }

    ngOnChanges(changes) {
        this.treeService.setData({
            options: changes.options && changes.options.currentValue,
            nodes: changes.nodes && changes.nodes.currentValue,
            events: _.pick(this, this.treeService.eventNames)
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/tree/components/tree.component.ts